import AssignmentIcon from '@mui/icons-material/Assignment';
import ShareIcon from '@mui/icons-material/Share';
import { Box, Typography } from '@mui/material';

const TitleComponent = ({ label, user, setDisplayedData }) => {
    const handleAssignmentClick = () => {
        console.log('Assignment Icon Clicked');
    };

    const handleShareClick = () => {
        console.log('Share Icon Clicked');
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', padding: '5px 5px 0px 45px' }}>
            <Box
                sx={{
                    display: 'flex',
                    maxHeight: '50px',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}
            >
                <Typography
                    sx={{
                        display: 'flex',
                        fontSize: '15px',
                        fontWeight: 'bold',
                        color: 'black',
                        lineHeight: '15px',
                        flexGrow: 1
                    }}
                >
                    ניהול קו לקוחות
                </Typography>
                <Box sx={{ display: 'flex', gap: '10px' }}>
                    <AssignmentIcon onClick={handleAssignmentClick} style={{ cursor: 'pointer' }} />
                    <ShareIcon onClick={handleShareClick} style={{ cursor: 'pointer' }} />
                </Box>
            </Box>
            לקוח: בדיקה
        </Box>
    );
};

export default TitleComponent;
